import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { UserAccountCheckUpdateRequestSchema, Language, Region, User, getUrlForLanguage } from "consumerhouse-shared";
import React, { useContext, useEffect, useState } from "react";
import { RouteComponentProps, useHistory } from "react-router";
import { AnyListener, Listener, useForm } from "typed-react-form";
import { string } from "yup";
import AuthContext from "../AuthContext";
import Button from "../components/Button";
import { ButtonContainer } from "../components/ButtonContainer";
import CenterContainer from "../components/CenterContainer";
import { Form, FormLabel, FormText, FormSelect, FormRow } from "../components/FormElements";
import Title from "../components/Title";
import { LanguageContext } from "../LanguageContext";
import { useLanguage } from "../useLanguage";
import { capitalize } from "../util";

export function UpdateSettings(props: RouteComponentProps<{ s: string }>) {
    const token = decodeURIComponent(props.match.params.s);
    const form = useForm({ telephoneNumber: "", language: "" as Language, regionName: "", token }, (values) =>
        UserAccountCheckUpdateRequestSchema.validate(values)
    );
    const [regions, setRegions] = useState<Region[]>([]);
    const { client, auth, setAuth } = useContext(AuthContext);
    const language = useLanguage();
    const history = useHistory();

    async function submit() {
        if (!(await form.validate())) return;
        form.setState({ isSubmitting: true });
        await client.fetch("/user/account-checkup/update", form.values);
        if (auth) {
            setAuth({
                ...auth,
                user: {
                    ...auth.user,
                    language: form.values.language,
                    activeRegionName: form.values.regionName,
                    telephoneNumber: form.values.telephoneNumber,
                },
            });
        }
        alert(language("account-checkup-done"));
        setTimeout(() => (window.location.href = getUrlForLanguage(form.values.language)), 400);
    }

    useEffect(() => {
        client.fetch("/region/list/public").then((e) => setRegions(e.regions));
        client.fetch("/user/account-checkup", { token }).then((e) => {
            if (e) {
                // typed-object-validator 'null is not acceptable' workaround
                if (!e.telephoneNumber) delete (e as any).telephoneNumber;
                if (!e.regionName) delete (e as any).regionName;
                if (!e.language) e.language = "nl";
                form.setDefaultValues({ ...e, token }, false);
            } else {
                history.push("/account/edit");
            }
        });
    }, []);

    return (
        <CenterContainer width="500px">
            <Title>{language("edit-account")}</Title>
            <Form
                onSubmit={(ev) => {
                    ev.preventDefault();
                    submit();
                }}>
                <FormRow>
                    <FormLabel>{language("user-telephone")}</FormLabel>
                    <FormText form={form} name="telephoneNumber" />
                </FormRow>
                <FormRow>
                    <FormLabel>{language("register-language")}</FormLabel>
                    <FormSelect form={form} name="language">
                        <option value="nl">Nederlands</option>
                        <option value="fr">Français</option>
                    </FormSelect>
                </FormRow>
                <FormRow>
                    <FormLabel>{language("regions-select")}</FormLabel>
                    <FormSelect form={form} name="regionName">
                        <option value="">Kies...</option>
                        {regions.map((e) => (
                            <option key={e.name} value={e.name}>
                                {capitalize(e.name)}
                            </option>
                        ))}
                    </FormSelect>
                </FormRow>
                <AnyListener
                    form={form}
                    render={({ state }) => (
                        <Button
                            style={{ margin: "1em 0" }}
                            loading={state.isSubmitting}
                            disabled={state.isSubmitting}
                            type="submit"
                            icon={faCheck}
                            color="#56a44f">
                            {language("edit-account-finish")}
                        </Button>
                    )}
                />
            </Form>
        </CenterContainer>
    );
}
